<!-- Generator: Adobe Illustrator 28.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg enable-background='new 0 0 250 205' height='205px' version='1.1' viewBox='0 0 250 205' width='250px' x='0px'
     xml:space='preserve' xmlns='http://www.w3.org/2000/svg' y='0px'>
<g id="graphics">

		<path d="
		M115.5,30.5h-3v8.4c1.6,3.4,1.6,7.4,0,10.8v6.6l5.9,22.2h8.5l0.6-0.6v-4.2v-4.2V56.5h5.9h6.1v13v4.2v4.2l0.6,0.6h7.8l9.2-22.1
		l2.4-9.1V30.5h-8H115.5V18.3c3.4,1.3,6.7,2.6,10.2,2.5c3.4-0.2,6.8-1.7,10.1-1.5c2.7,0.2,5.3,1.4,8,1.9c2.5,0.5,5.1,0.3,7.7,0v8.3" fill="#DADADA" id="Werkzeugaufnahme_1_" stroke="#707070" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
    />

  <line fill="none" id="Markierung_OWH_2_00000173140779776867014850000007556938523883559609_" stroke="#285172" stroke-miterlimit="10" x1="135" x2="212" y1="202.5" y2="202.5"/>

  <line fill="none" id="Markierung_OWH_00000067925884958482024900000000560528415325091469_" stroke="#285172" stroke-miterlimit="10" x1="151" x2="222" y1="78.5" y2="78.5"/>
  <g id="Pfeil_OWH_00000142172343208413981650000003384256466019514278_">
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="194.5" x2="194.5" y1="82.6" y2="199.4"/>
      <g>
				<polygon fill="#285172" points="192,83.3 194.5,79 197,83.3 				"/>
			</g>
      <g>
				<polygon fill="#285172" points="192,198.7 194.5,203 197,198.7 				"/>
			</g>
		</g>
	</g>

  <path d="
		M131.6,202.4L27.9,106.7c-1.3-1.2-1.3-3.1-0.1-4.4l56.3-57.1L192.3,145l-56.5,57.3C134.7,203.4,132.8,203.5,131.6,202.4z" fill="none" id="Schachtel_00000078022885855397214450000002910620388820542862_" stroke="#707070" stroke-miterlimit="10"/>
  <g id="Pfeil_Schachtelinnenhöhe_00000072266797463710670740000015423958233962215346_">
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="34.8" x2="88" y1="108.2" y2="54.3"/>
      <g>
				<polygon fill="#285172" points="37.1,109.4 32.3,110.8 33.5,105.9 				"/>
			</g>
      <g>
				<polygon fill="#285172" points="89.2,56.6 90.5,51.8 85.7,53.1 				"/>
			</g>
		</g>
	</g>
  <g id="Pfeil_Modufix_00000010275008220560779050000014488415930284359833_">
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="129.4" x2="122.6" y1="42.5" y2="42.5"/>
      <g>
				<polygon fill="#285172" points="128.7,40 133,42.5 128.7,45 				"/>
			</g>
      <g>
				<polygon fill="#285172" points="123.3,40 119,42.5 123.3,45 				"/>
			</g>
		</g>
	</g>

  <line fill="none" id="Markierung_Modufix_00000066486011468581027450000015093709498747053194_" stroke="#285172" stroke-miterlimit="10" x1="118.5" x2="118.5" y1="35" y2="79"/>

  <line fill="none" id="Markierung_Modufix_1_00000029023174953404404040000010413005135749318581_" stroke="#285172" stroke-miterlimit="10" x1="133.5" x2="133.5" y1="35" y2="64"/>
  <polyline fill="#9A9A9A" points="140.5,124 140.5,94 150.5,84.1 150.5,78.5 139.6,78.5
		139.5,78.5 139.5,78.4 139.5,69.3 137.5,67.3 137.5,66.5 139.5,64.5 139.5,59.1 138.9,58.5 128.1,58.5 127.5,59.1 127.5,64.5
		129.5,66.5 129.5,67.3 127.5,69.3 127.5,78.4 127.5,78.5 127.4,78.5 116.5,78.5 116.5,84.1 126.5,94 126.5,124.3 126.5,94.1
		126.5,192.6 131.6,201.4 131.9,201.8 132.4,202.2 132.9,202.4 133.4,202.5 133.5,202.5 134,202.4 134.4,202.3 134.9,202
		135.4,201.5 135.4,201.4 140.5,192.6 140.5,94 	" stroke="#707070" stroke-miterlimit="10"/>
</g>
  <g id="texts">
	<rect fill="none" height="23.7" width="68.4" x="92.2" y="4.9"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="halfPressBarDistance" transform="matrix(1 0 0 1 105.9473 13.8096)">{{halfPressBarDistance}}</text>
    <rect fill="none" height="23.7" width="50.9" x="199.3" y="136.5"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="upperToolHeight" transform="matrix(1 0 0 1 199.3332 145.3799)">{{upperToolHeight}}</text>
    <rect fill="none" height="23.7" width="64.3" x="3.3" y="37.5"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="innerBoxHeight" transform="matrix(1 0 0 1 11.2058 46.4047)">{{innerBoxHeight}}</text>
</g>
</svg>
